const mapMicrocopySet = (microcopySet) => {
  return (
    microcopySet &&
    microcopySet.items.reduce((obj, label) => {
      return {
        [label.title]: label.text,
        ...obj,
      }
    }, {})
  )
}

export default mapMicrocopySet
